module.exports = __webpack_public_path__ + "img/daa513241094f5a5a947e7e33c4c028.b3bc0dc9.jpg";